<script>

    export let label = null
    export let value = null
    export let placeholder = null
    export let pattern = null

    export let required = true
    export let step = null
    export let max = null
    export let min = null

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <input bind:value={ value } class="input" type="number" { pattern } { step } { max } { min } { placeholder } { required }>
    </div>
</div>
